import React from "react";

const DarkCross = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.85378 9.14604C9.90024 9.1925 9.93709 9.24765 9.96223 9.30834C9.98737 9.36904 10.0003 9.43409 10.0003 9.49979C10.0003 9.56549 9.98737 9.63054 9.96223 9.69124C9.93709 9.75194 9.90024 9.80709 9.85378 9.85354C9.80733 9.9 9.75218 9.93684 9.69148 9.96199C9.63079 9.98713 9.56573 10.0001 9.50003 10.0001C9.43434 10.0001 9.36928 9.98713 9.30859 9.96199C9.24789 9.93684 9.19274 9.9 9.14628 9.85354L5.00003 5.70666L0.853784 9.85354C0.759964 9.94736 0.632716 10.0001 0.500034 10.0001C0.367352 10.0001 0.240104 9.94736 0.146284 9.85354C0.0524635 9.75972 -0.000244138 9.63247 -0.000244141 9.49979C-0.000244143 9.36711 0.0524635 9.23986 0.146284 9.14604L4.29316 4.99979L0.146284 0.85354C0.0524635 0.759719 -0.000244141 0.632472 -0.000244141 0.49979C-0.000244141 0.367108 0.0524635 0.23986 0.146284 0.14604C0.240104 0.0522194 0.367352 -0.000488281 0.500034 -0.000488281C0.632716 -0.000488281 0.759964 0.0522194 0.853784 0.14604L5.00003 4.29291L9.14628 0.14604C9.2401 0.0522194 9.36735 -0.000488284 9.50003 -0.000488281C9.63272 -0.000488279 9.75996 0.0522194 9.85378 0.14604C9.94761 0.23986 10.0003 0.367108 10.0003 0.49979C10.0003 0.632472 9.94761 0.759719 9.85378 0.85354L5.70691 4.99979L9.85378 9.14604Z"
      fill="#3A383F"
    />
  </svg>
);

export default DarkCross;
